import React from "react";
import { NavLink } from "react-router-dom";
import PropTypes from "prop-types";
import {
  createStyles,
  ListItem as MuiListItem,
  ListItemIcon,
  withStyles,
} from "@material-ui/core";
import translate from "i18n/translate";
import { Typography } from "components/common";
import { DefaultIcon } from "components/common/SrIcon";

const ListItem = withStyles((theme) =>
  createStyles({
    root: {
      height: "2.62rem",
      "&.active": {
        backgroundColor: theme.palette.secondary.main,
        "&>p": {
          color: "white",
        },
        "&>div>svg": {
          fill: "white",
        },
      },
    },
  })
)(MuiListItem);

const MenuItem = ({ label, path, Icon, onMenuItemClick }) => (
  <ListItem component={NavLink} to={path} button onClick={onMenuItemClick}>
    <ListItemIcon>
      <Icon fontSize="large" />
    </ListItemIcon>
    <Typography variant="body2">{translate(label)}</Typography>
  </ListItem>
);

MenuItem.defaultProps = {
  Icon: DefaultIcon,
};

MenuItem.propTypes = {
  path: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  Icon: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
};

export default MenuItem;
